import React from 'react';
import ContentPasteOffRoundedIcon from '@mui/icons-material/ContentPasteOffRounded';
import {useNavigate} from 'react-router-dom';
import AdmicityStatus from '../../../../shared-components/AdmicityStatus';
import {getFormRequestStatusInfo} from '../common/common';
import {useGetFormRequestsQuery} from '../../../../api/services/formRequestsService';
import withPagination from '../../../../hoc/pagination/withPagination';
import AdmicityTable from '../../../../shared-components/AdmicityTable';
import useUser from '../../../../utility/hooks/useUser';

const tableProps = {
    columns: [
        {
            field: 'formName',
            headerName: 'Form Name',
            editable: false,
            sortable: false,
            minWidth: 300,
            flex: 1,
        },
        {
            field: 'status',
            headerName: 'Status',
            editable: false,
            sortable: false,
            minWidth: 200,
            renderCell: (params) => params.row.status &&
                <AdmicityStatus {...getFormRequestStatusInfo(params.row.status)}/>,
            flex: 1,
        },
        {
            field: 'assignee',
            headerName: 'Assignee',
            editable: false,
            sortable: false,
            minWidth: 500,
            flex: 2,
        }
    ],
    pageSize: 25
};

const RequestAndResponses = () => {
    const {user} = useUser();
    const navigate = useNavigate();

    const Table = withPagination(AdmicityTable, useGetFormRequestsQuery, {role: user.role});

    return (
        <Table
            sx={{
                marginLeft: 2
            }}
            columns={tableProps.columns}
            handleRowClick={(params) => navigate(`${params.row.formRequestId}`)}
            noRowsOverlay={{
                icon: <ContentPasteOffRoundedIcon/>,
                text: 'No requests and responses yet'
            }}
        />
    );
};

export default RequestAndResponses;